export const modalService = {
    setup(modal) {
        this.open = modal.open;
        this.close = modal.close;
    },
    open: (_content) => console.warn('Modal service is not setup.'),
    close: () => console.warn('Modal service is not setup.'),
};
